import { render, staticRenderFns } from "./ActivationsList.view.vue?vue&type=template&id=0bb2e932"
import script from "./ActivationsList.view.vue?vue&type=script&lang=js"
export * from "./ActivationsList.view.vue?vue&type=script&lang=js"
import style0 from "./ActivationsList.view.vue?vue&type=style&index=0&id=0bb2e932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports